import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  private readonly path = environment.apiUrl;
  private readonly route = 'countries';

  constructor(private httpClient: HttpClient) {}

  getList(filter?: Record<string, any>): Observable<any> {
    let httpParams = new HttpParams();

    if (filter) {
      Object.keys(filter).forEach((param) => {
        const value = filter[param];

        if (value !== undefined && value !== null) {
          httpParams = httpParams.set(param, String(value));
        }
      });
    }

    return this.httpClient.get<any>(`${this.path}/${this.route}`, {
      params: httpParams,
    });
  }
}